<template>
    <div>
    	<img src="../assets/img/detail/dhw/1.jpg" width="100%" />
    	<img src="../assets/img/detail/dhw/2.jpg" width="100%"/>
    	<img src="../assets/img/detail/dhw/3.jpg" width="100%"/>
    	<img src="../assets/img/detail/dhw/4.jpg" width="100%"/>
    	<img src="../assets/img/detail/dhw/5.jpg" width="100%"/>
    	<img src="../assets/img/detail/dhw/6.jpg" width="100%"/>
    	<img src="../assets/img/detail/dhw/7.jpg" width="100%"/>
    	<img src="../assets/img/detail/dhw/8.jpg" width="100%"/>
    	<img src="../assets/img/detail/dhw/9.jpg" width="100%"/>
    	<img src="../assets/img/detail/dhw/10.jpg" width="100%"/>
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>